export default __webpack_public_path__ + "static/media/undraw_Online_shopping.8d0be4a4.svg";